const PREFIX = "jmurillo.variant-filter.";


const ActionTypes = Object.freeze({
	PREFIX: PREFIX,
	CLEAN: PREFIX + "clean",
});


export default ActionTypes;